import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { Box, Icon } from '@mui/material';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';

export default function HelpIconModal(props: { title: string, content: Document, color: string, iconText?: string }) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (event: React.SyntheticEvent) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const theme = useTheme();

  const BoxStyled = styled(Box)`
    color: ${props.color === 'light' ? 'white' : theme.palette.primary.main};

    :hover {
      color: ${props.color === 'light' ? '#cccccc' : theme.palette.primary.light};
    }
    display: flex;
    align-items: center;
    column-gap: 4px;

    cursor: pointer;
  `;
  
  const IconStyled = styled(Icon)`
    font-size: 18px!important;
  `;

  const descriptionElementRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <>
      <BoxStyled onClick={handleClickOpen}>
        <IconStyled>help_outline</IconStyled> <span>{props.iconText}</span>
      </BoxStyled>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={'body'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {props.title}
        </DialogTitle>

        <DialogContent dividers={true}>
          {documentToReactComponents(props.content)}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>

      </Dialog>
    </>
  );
}
